import { BsHomePage } from './BsHomePage';
export default BsHomePage;
